import React, { useState, useEffect } from "react";
import "./InstallPWA.css";

const APP_NAME = "Portal de Pacientes";
const IOS_DISMISSED_KEY = "iosModalDismissedCgap";

const InstallPWA = () => {
  const [showModal, setShowModal] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    const isIOSDevice =
      /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    const isAndroidDevice = /Android/i.test(navigator.userAgent);

    setIsIOS(isIOSDevice);
    setIsAndroid(isAndroidDevice);

    if (!isIOSDevice) {
      const handler = (e) => {
        e.preventDefault();
        setDeferredPrompt(e);
        setShowModal(true);
      };

      window.addEventListener("beforeinstallprompt", handler);

      const androidFallbackTimer = isAndroidDevice
        ? setTimeout(() => setShowModal(true), 2000)
        : null;

      return () => {
        window.removeEventListener("beforeinstallprompt", handler);
        if (androidFallbackTimer) {
          clearTimeout(androidFallbackTimer);
        }
      };
    } else {
      const hasSeenIOSInstructions = localStorage.getItem(IOS_DISMISSED_KEY);
      if (!hasSeenIOSInstructions) {
        const timer = setTimeout(() => setShowModal(true), 2000);
        return () => clearTimeout(timer);
      }
    }
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;

    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;

    if (outcome === "accepted") {
      setDeferredPrompt(null);
    }
    setShowModal(false);
  };

  const handleModalClose = () => {
    setShowModal(false);
    if (isIOS) {
      localStorage.setItem(IOS_DISMISSED_KEY, "true");
    }
  };

  if (!showModal) return null;

  return (
    <div className="pwa-modal-overlay">
      <div className="pwa-modal" role="dialog" aria-modal="true">
        <div className="pwa-modal-header">
          <img
            className="pwa-modal-logo"
            src="assets/icon/logo.jpg"
            alt=""
            aria-hidden="true"
          />
          <h2>Instalar {APP_NAME}</h2>
        </div>
        {isIOS ? (
          <div className="ios-instructions">
            <p>Para instalar la aplicación en tu iPhone o iPad:</p>
            <ol>
              <li>Tocá el botón "Compartir" en la barra de Safari</li>
              <li>Desplazate y seleccioná "Agregar a la pantalla de inicio"</li>
              <li>Tocá "Agregar" en la ventana que aparece</li>
            </ol>
            <p>Listo. La app aparecerá en tu pantalla de inicio.</p>
          </div>
        ) : (
          <div className="android-instructions">
            <p>
              Instalá {APP_NAME} en tu dispositivo para un acceso más rápido y
              una mejor experiencia.
            </p>
            {isAndroid && !deferredPrompt && (
              <>
                <p>
                  Si no aparece el instalador automático, usá el menú de Chrome.
                </p>
                <ol>
                  <li>Tocá el menú de tres puntos.</li>
                  <li>Elegí Instalar app o Agregar a pantalla principal.</li>
                  <li>Confirmá la instalación.</li>
                </ol>
              </>
            )}
          </div>
        )}
        <div className="pwa-modal-buttons">
          {!isIOS && deferredPrompt && (
            <button onClick={handleInstall} className="install-button">
              Instalar
            </button>
          )}
          <button onClick={handleModalClose} className="close-button">
            {isIOS ? "Entendido" : "Ahora no"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPWA;
